import { LucideIcon, Zap } from 'lucide-react';
import { HelpHint } from '@/components/help/HelpHint';

interface SectionHeaderProps {
  title: string;
  subtitle: string;
  icon?: LucideIcon;
  /** Si se pasa, muestra un botón `?` que abre la ayuda contextual
   *  de esa sección (contenido en src/lib/helpContent.ts). */
  helpId?: string;
}

export function SectionHeader({ title, subtitle, icon: Icon, helpId }: SectionHeaderProps) {
  return (
    <div className="relative flex flex-col items-start justify-between gap-3 md:gap-4 border-b-8 border-primary pb-4 md:pb-6 mb-8 md:mb-12 animate-fade-in overflow-hidden">
      {/* Decorative accent line */}
      <div className="absolute bottom-0 left-0 w-24 h-1 bg-accent glow-accent-sm"></div>

      <div className="min-w-0 relative z-10 w-full">
        <div className="flex items-center gap-2 md:gap-3 mb-2">
          {Icon && (
            <div className="relative">
              <Icon className="w-6 h-6 md:w-8 md:h-8 text-accent shrink-0 transition-transform duration-300 hover:scale-110" />
              <div className="absolute inset-0 bg-accent/20 blur-xl rounded-full"></div>
            </div>
          )}
          <h2 className="text-3xl sm:text-4xl md:text-7xl font-black italic uppercase tracking-tighter leading-none break-words min-w-0">
            {title}
          </h2>
          {helpId && (
            <div className="ml-auto self-start shrink-0">
              <HelpHint helpId={helpId} />
            </div>
          )}
        </div>
        <p className="text-[10px] md:text-sm font-bold bg-accent text-accent-foreground px-2 md:px-3 py-1 inline-block uppercase tracking-[0.2em] md:tracking-[0.3em] glow-accent-sm">
          {subtitle}
        </p>
      </div>
    </div>
  );
}
